View = require 'app/scripts/views/internal/view'
sidebarAction = require 'app/scripts/views/templates/card_detail_sidebar_button'

module.exports = class CardAgingCardButtonView extends View
  tagName: 'span'

  renderOnce: ->
    @$el.html(sidebarAction('js-card-aging-card-button', 'card', 'card-aging'))
    @